import template from './index-metric-get.template.html';
import controller from './index-metric-get.controller';

const indexMetricGetComponent = {
  bindings: {
    stats: '<',
    summary: '<'
  },
  template,
  controller,
  controllerAs: 'indexMetricGetCtrl'
};

export default indexMetricGetComponent;



// WEBPACK FOOTER //
// ./ui/src/components/index-metric-get/index-metric-get.component.js